export default function BurgerIcon({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fill="#884D00"
        d="M18.875 11.789a1.304 1.304 0 0 1-1.308 1.308H2.433a1.308 1.308 0 0 1 0-2.616h15.134a1.308 1.308 0 0 1 1.308 1.308Z"
      />
      <path
        fill="#AA6100"
        d="M18.758 11.246a1.305 1.305 0 0 1-1.19.766H2.432a1.31 1.31 0 0 1-1.19-.766 1.31 1.31 0 0 1 1.19-.765h15.134c.529 0 .985.313 1.19.765Z"
      />
      <path
        fill="#FFA733"
        d="M20 14.153c0 1.685-.78 2.937-2.042 3.768-1.261.83-3.004 1.24-4.928 1.24H6.97c-3.849 0-6.97-1.638-6.97-5.008 0-.188.047-.366.131-.527.072-.136.17-.26.29-.364.26-.228.621-.37 1.018-.37h17.122c.58 0 1.08.301 1.308.735.084.16.131.338.131.526Z"
      />
      <path
        fill="#FFB655"
        d="M19.869 13.627c-.272 1.122-.952 1.996-1.91 2.627-1.262.83-3.005 1.24-4.93 1.24H6.972c-3.387 0-6.21-1.267-6.84-3.868.072-.136.17-.26.29-.364.26-.228.621-.37 1.018-.37h17.122c.58 0 1.08.302 1.308.735Z"
      />
      <path
        fill="#EEBF00"
        d="m15.562 9.932-3.384 3.383a1.841 1.841 0 0 1-2.604 0L6.191 9.932h9.371Z"
      />
      <path
        fill="#FFD422"
        d="m15.562 9.932-3.384 3.383c-.085.085-.175.16-.271.224a1.827 1.827 0 0 1-.706-.44L8.034 9.932h7.528Z"
      />
      <path
        fill="#6DC82A"
        d="M19.62 10.404c0 .177-.029.358-.093.535-.248.693-.913.962-1.432.58l-.621-.46c-.434-.32-.987-.189-1.301.31l-.027.041c-.301.48-.826.622-1.255.341l-1.392-.91a.832.832 0 0 0-1.01.06l-1.116.908a.834.834 0 0 1-1.058.028l-1.273-.943a.833.833 0 0 0-1.047.02l-1.16.92a.832.832 0 0 1-1.023.038l-1.5-1.043a.827.827 0 0 0-.95-.015l-1.4.916c-.932.12-1.385-.565-1.385-.565a1.562 1.562 0 0 1-.125-1.233c.144-.461.491-.817.943-.817h17.21c.443 0 .797.35.943.815.047.148.072.309.072.474Z"
      />
      <path
        fill="#7ED63E"
        d="M19.548 9.93a1.21 1.21 0 0 1-.02.06c-.249.694-.914.963-1.432.58l-.622-.46c-.434-.32-.987-.188-1.301.31l-.027.042c-.3.479-.826.621-1.255.34l-1.392-.91a.831.831 0 0 0-1.01.06l-1.116.908a.834.834 0 0 1-1.058.028l-1.272-.943a.833.833 0 0 0-1.048.02l-1.16.92a.833.833 0 0 1-1.023.038l-1.5-1.042a.825.825 0 0 0-.95-.015l-1.4.915c-.932.12-1.385-.565-1.385-.565a1.454 1.454 0 0 1-.125-.284c.144-.461.491-.817.943-.817h17.21c.443 0 .797.35.943.815Z"
      />
      <path
        fill="#FF3501"
        d="M19.273 8.278a1.312 1.312 0 0 1-1.31 1.338c-2.35 0-8.61-.053-9.554-.021l-.063.002c-1.192.045-1.464.236-1.464.871v2.326a.432.432 0 0 1-.433.433.433.433 0 0 0-.434.433v1.013a1.266 1.266 0 0 1-1.27 1.263h-.031A1.232 1.232 0 0 1 3.482 14.7l.005-1.833a.51.51 0 0 1 .511-.51.511.511 0 0 0 .512-.51v-1.379a.852.852 0 0 0-.853-.852H2.063C1.345 9.616.74 9.05.727 8.332a1.312 1.312 0 0 1 1.31-1.338h15.9c.717 0 1.322.567 1.336 1.284Z"
      />
      <path
        fill="#FF5023"
        d="M19.273 8.278c.003.136-.015.266-.05.39-2.488-.003-8.433-.052-9.35-.022-1.246.04-1.527.227-1.527.874v.077c-1.193.045-1.464.236-1.464.871v2.326a.432.432 0 0 1-.433.433.433.433 0 0 0-.434.433v1.013c0 .103-.012.203-.035.299a1.233 1.233 0 0 1-1.035-1.22l.006-1.834a.509.509 0 0 1 .511-.51.511.511 0 0 0 .511-.51V9.52a.852.852 0 0 0-.852-.852H3.526c-.717 0-1.321-.567-1.336-1.284a1.31 1.31 0 0 1 .05-.39h15.696c.718 0 1.323.567 1.337 1.284Z"
      />
      <path
        fill="#EEBF00"
        d="m11.772 5.662-2.9 2.902a2.578 2.578 0 0 1-3.65 0L2.32 5.662h9.452Z"
      />
      <path
        fill="#FFD422"
        d="m11.772 5.662-2.9 2.902a2.56 2.56 0 0 1-1 .62 2.558 2.558 0 0 1-.997-.62L3.973 5.662h7.8Z"
      />
      <path
        fill="#FFA733"
        d="M20 6.07c0 .022 0 .043-.002.064A1.078 1.078 0 0 1 18.92 7.15H1.08A1.08 1.08 0 0 1 0 6.07C0 4.775.6 3.8 1.506 3.068c.736-.595 1.673-1.032 2.655-1.352C6.907.822 10 .84 10 .84S20 .785 20 6.07Z"
      />
      <path
        fill="#FFB655"
        d="M20 6.07c0 .022 0 .043-.002.064H3.276a1.08 1.08 0 0 1-1.08-1.08c0-1.295.6-2.27 1.506-3.003.146-.118.299-.229.459-.335C6.907.822 10 .84 10 .84S20 .785 20 6.07Z"
      />
      <path
        fill="#FFF5CC"
        d="M15.375 2.729a.457.457 0 0 1-.665.628c-.173-.184-.492-.82-.309-.993.184-.174.8.181.974.365Zm-2.423 2.26a.457.457 0 0 1-.854.327c-.09-.236-.144-.945.092-1.036.236-.09.671.472.762.708Zm-2.495-1.881a.457.457 0 1 1-.914 0c0-.253.205-.934.457-.934.253 0 .457.681.457.934ZM7.944 5.274a.457.457 0 0 1-.886-.229c.063-.244.432-.853.676-.79.245.064.273.775.21 1.019Zm-2.516-1.99a.457.457 0 0 1-.822-.4c.11-.227.59-.75.818-.64.227.11.115.812.004 1.04Z"
      />
    </svg>
  );
}
